import CurrencyIcon from "@/components/icons/CurrencyIcon";
import { handlePriceByComma } from "@/helpers/common/handlePrice";
import { validatePrice } from "@/helpers/product";
import Link from "next/link";
import React, { useMemo } from "react";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export default function BundleInfo({ data, locale }) {
  const products = useMemo(
    () => data?.sort((a, b) => a?.position - b?.position),
    [data]
  );

  // const { length } = products;

  return (
    products?.length > 0 && (
      <section className="rtl:text-start">
        <p className="font-bold">
          {locale === "ar"
            ? "الخيارات الأخرى المتوفرة"
            : "Other Available Options"}
        </p>

        <Swiper
          loop
          className="mt-8"
          key={locale}
          dir={locale === "en" ? "ltr" : "rtl"}
          spaceBetween={20}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true, enabled: true }}
        >
          {products?.map((item) => {
            const price = validatePrice(item?.prices_with_tax);

            return (
              <SwiperSlide key={item?.sku} className="mb-8">
                <Link
                  href={`/product/${item?.rewrite_url}`}
                  className="block p-2 rounded-md border border-[#4A63A9]"
                >
                  <h4 className="font-bold text-sm text-ellipsis text-[#4A63A9] mb-2 min-h-10">
                    {item?.name}
                  </h4>
                  <div className="flex items-center justify-between">
                    <div>
                      <span className="text-zinc-600">
                        {locale === "ar" ? "الكود" : "SKU"}:{" "}
                      </span>
                      <span className="text-black">{item?.sku}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="font-bold flex items-center gap-1 text-[#4A63A9]">
                        {handlePriceByComma(
                          price?.specialPrice || price?.originalPrice
                        )}
                        <CurrencyIcon className="size-3.5" />
                      </span>
                      {price?.specialPrice && (
                        <span className="flex items-center gap-1 text-sm line-through text-zinc-400">
                          {handlePriceByComma(price?.originalPrice)}
                          <CurrencyIcon className="size-3.5" />
                        </span>
                      )}
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </section>
    )
  );
}
